import { motion } from 'framer-motion';

import { useAccordionItemContext } from '../contexts/accordion-item-context';

export const SimpleAccordionDetails = ({
	className,
	children 
}: {
	className?: string;
	children: React.ReactNode;
}) => {
	const { expanded } = useAccordionItemContext();
	
	return (
		<motion.div 
			className={className}
			animate={expanded ? 'open' : 'closed'}
			initial={{ height: 0 }}
			variants={{
				open: { height: 'auto' },
				closed: { height: 0 }
			}}
		>
			{children}
		</motion.div>
	);
};